import { applyPreferences, getPreferences, preferenceDefaults, savePreferences } from '@/utils/preferences'

const state = {
  preferences: getPreferences(),
  globalLoading: false
}

const mutations = {
  SET_GLOBAL_LOADING(state, value) {
    state.globalLoading = !!value
  },
  TOGGLE_SIDEBAR(state) {
    state.preferences = savePreferences({ sidebarCollapsed: !state.preferences.sidebarCollapsed })
    applyPreferences(state.preferences)
  },
  CLOSE_SIDEBAR(state) {
    state.preferences = savePreferences({ sidebarCollapsed: true })
    applyPreferences(state.preferences)
  },
  SET_PREFERENCE(state, { key, value }) {
    state.preferences = savePreferences({ [key]: value })
    applyPreferences(state.preferences)
  },
  SET_PREFERENCES(state, preferences) {
    state.preferences = savePreferences(preferences)
    applyPreferences(state.preferences)
  },
  RESET_PREFERENCES(state) {
    state.preferences = savePreferences(preferenceDefaults)
    applyPreferences(state.preferences)
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
